import React, { useEffect, useState, useCallback } from "react";
import Line from "../../main/Line";
import BackButton from "../../main/BackButton";
import axios from "../../../axios-backend";
import Button from "../../main/Button";
import { useLocation, useNavigate } from "react-router-dom";

const AdOption = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const sid = searchParams.get("sid");

  const [content, setContent] = useState("");
  const [index, setIndex] = useState(0);

  const getData = useCallback(() => {
    if (!id) {
      return;
    } else {
      axios
        .get("/option", {
          params: { id: id },
        })
        .then((data) => {
          setContent(data.data.data[0].content);
          setIndex(data.data.data[0].index);
        });
    }
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleSubmit = () => {
    if (id === null) {
      axios
        .post("/option", {
          stepsId: sid,
          content,
          index,
        })
        .then((data) => {
          if (data.status === 200) {
            navigate(-1);
          }
        });
    } else {
      axios
        .patch("/option", {
          id: id,
          content,
          index,
        })
        .then((data) => {
          if (data.status === 200) {
            navigate(-1);
          }
        });
    }
  };

  const handleDelete = () => {
    if (window.confirm("Do you really want to delete this option?")) {
      axios
        .delete("/option", {
          data: {
            id: id,
          },
        })
        .then((data) => {
          if (data.status === 200) {
            navigate(-1);
          }
        });
    } else {
      return;
    }
  };

  return (
    <>
      <BackButton />
      <Line type="bottom-line">if you are adding options for "three options" or "multiple options", please set the index to 0, 1, 2, 3...</Line>
      <Line type="bottom-line">
        <label>Content:</label>
        <input
          id="name"
          style={{ width: "300px", marginLeft: "2rem" }}
          value={content}
          onChange={(e) => {
            setContent(e.target.value);
          }}
        />
      </Line>
      <Line type="bottom-line">
        Index:
        <input
          type="text"
          value={index}
          style={{ width: "300px", marginLeft: "2rem" }}
          onChange={(e) => {
            setIndex(e.target.value);
          }}
        />
      </Line>
      <Line>
        <Button style={{ marginRight: "2rem" }} onClick={() => handleSubmit()}>
          Submit
        </Button>
        {id === null ? null : (
          <Button onClick={() => handleDelete()}>Delete</Button>
        )}
      </Line>
    </>
  );
};

export default AdOption;
